// extracted by css-extract-rspack-plugin
export default {"cardContent":"ConfirmBeneficiaryModal_cardContent__JO4tJ"};